module.exports = __webpack_public_path__ + "static/media/Titan.ff271fea.png";